import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

/** Brand-refresh ribbon UI only when REACT_APP_BRAND_REFRESH_ENABLED === 'true'. */
export const isRibbonBannerBrandRefresh = () => isBrandRefreshEnabled();

/** data-region value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getRibbonRegionProps = () =>
  isBrandRefreshEnabled() ? 'ribbon-banner' : undefined;

/** data-part value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getRibbonPartProps = (part) =>
  isBrandRefreshEnabled() ? part : undefined;
